import { render } from "./UiPropColor.vue?vue&type=template&id=6249a4b6"
import script from "./UiPropColor.vue?vue&type=script&lang=js"
export * from "./UiPropColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__